<script>
import Banner from 'dashboard/components/ui/Banner.vue';

const padTime = value => String(value).padStart(2, '0');

export default {
  components: { Banner },
  emits: ['stay-connected'],
  props: {
    remainingMs: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    remainingTimeLabel() {
      const totalSeconds = Math.max(Math.ceil(this.remainingMs / 1000), 0);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      return `${minutes}:${padTime(seconds)}`;
    },
    bannerMessage() {
      return this.$t('GENERAL_SETTINGS.SESSION_TIMEOUT.WARNING', {
        timeRemaining: this.remainingTimeLabel,
      });
    },
  },
};
</script>

<template>
  <Banner
    color-scheme="warning"
    :banner-message="bannerMessage"
    has-action-button
    action-button-variant="solid"
    action-button-label="$t('GENERAL_SETTINGS.SESSION_TIMEOUT.KEEP_ALIVE')"
    action-button-icon="i-lucide-refresh-cw"
    @primary-action="$emit('stay-connected')"
  />
</template>
